import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectSaleTypes = createSelector(selectJsonQuery, jsonQuery => getTermsValue('sost_type')(jsonQuery));
